import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/azure-caf-pnp-banner.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Azure "),
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://learn.microsoft.com/en-us/azure/cloud-adoption-framework/",
        target: "_blank",
        rel: "noopener"
      }, "Cloud Adoption Framework")
    ]),
    /*#__PURE__*/_createTextVNode(" (aka CAF) provides proven guidelines and best practices that help you confidently adopt the cloud and achieve business outcomes. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " This portal aims to consolidate the most common strategies adopted by teams and organisations across the world into one place. We aim to provide tools and quick access to the most up-to-date rules and guidelines to name and tag your Azure resources, laying the foundation for a well-governed cloud environment. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, { src: _imports_0 })
    ]),
    _hoisted_3
  ]))
}